export * from './injectScript'
